<template>
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
      <path d="m12 3 8 4.5-8 4.5-8-4.5L12 3Z" stroke-linejoin="round" />
      <path d="M4 7.5v4.232l8 4.768 8-4.768V7.5M12 20v-3.5M9.322 20.25h5.357" />
    </g>
  </svg>
</template>
